import { configureStore } from '@reduxjs/toolkit';

import authenticationReducer from './slices/authentication';
import invalidTokenModalReducer from './slices/invalid-token-modal-slice';
import colorModeReducer from './slices/colorModeSlice';
import sidebarNavigationReducer from './slices/sidebarNavigation';
import navigationReducer from './slices/navigation';
import profileDialogReducer from './slices/profileEditorDialog';
import fullScreenLoadingReducer from './slices/fullSrceenLoadingSlice';
import confirmDialogReducer from './slices/confirmDialogSlice';
import addToCompanyReducer from './slices/addToCompanySlice';
import InvoiceDetailsDialogReducer from './slices/invoiceDetailsDialogSlice';

// ...

export const store = configureStore({
    reducer: {
        invalidTokenModal: invalidTokenModalReducer,
        authentication: authenticationReducer,
        sidebarNavigation: sidebarNavigationReducer,
        colorMode: colorModeReducer,
        navigation: navigationReducer,
        profileDialog: profileDialogReducer,
        fullScreenLoading: fullScreenLoadingReducer,
        confirmDialog: confirmDialogReducer,
        invoiceDetailsDialog: InvoiceDetailsDialogReducer,
        addToCompanyDialog: addToCompanyReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
